import { TokenProvider, OidcUser } from "./TokenProvider";
import { UserInfo } from "./types";
import { TidSettings } from "./tidSettings";

interface User {
  firstName?: string
  lastName?: string
  idToken?: string
  accessToken?: string
}

const auth = new TokenProvider(TidSettings);

let userInfo: User;

export async function GetUserInfo(
  onUserUpdateCallback: (user: UserInfo) => void
) {
  console.log("signing in");

  const callback = (oidcUser: OidcUser) => {
    const u = { 
      accessToken: oidcUser.access_token, 
      idToken: oidcUser.id_token
    }
    userInfo = u
    const user = tokenUserToUserInfo(u);
    onUserUpdateCallback(user);
  };

  try {
    await auth.signIn(callback); // Sets userInfo or redirects...
    if (userInfo) {
      console.log("returning userInfo: ", userInfo);
      return tokenUserToUserInfo(userInfo);
    } else {
      // wait for redirect
      return;
    }
  } catch (e) {
    console.error("Caught error in signin: ", e);
    throw e;
  }
}

function tokenUserToUserInfo(u: User): UserInfo {
  return {
    firstName: u.firstName, // Not used
    lastName: u.lastName, // Not used
    idToken: u.idToken,
    accessToken: u.accessToken,
  };
}
